<template>
    <div id="FormOrientation">
        <div class="header">
            <div class="icon-container">
                <i class="md-icon">confirmation_number</i>
            </div>
            <div class="text-container">
                <div class="title">{{ $t("form.redicetFormAnswer") }}</div>
                <div class="description">
                    {{ $t("form.redicetFormAnswerDesc") }}
                </div>
            </div>
        </div>
        <div class="content">
            <div class="left">
                <i class="md-icon">confirmation_number</i>
                <span>{{ $t("form.rediectAnswersToTicket") }}</span>
            </div>
            <div class="right">
                <label class="switch">
                    <input type="checkbox" v-model="ticketMode">
                    <span class="slider round"></span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FormOrientation",
    props: {
        formId: {
            type: String,
            required: true,
        },
        siteId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            ticketMode: false,
        };
    },
    async mounted() {
        await this.loadForm();
    },
    watch: {
        ticketMode(newVal) {
            this.updateTicketMode(newVal);
        },
    },
    methods: {
        ...mapActions({
            getFormById: "forms/getFormById",
            updateFormData: "forms/updateFormData",
        }),
        async loadForm() {
            const response = await this.getFormById({ siteId: this.siteId, formId: this.formId });
            this.ticketMode = response.form.ticketMode;
        },
        async updateTicketMode(value) {
            try {
                await this.updateFormData({
                    siteId: this.siteId,
                    formId: this.formId,
                    formData: { ticketMode: value },
                });
            } catch (error) {
                console.error(this.$t("form.errorTicketMode"), error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#FormOrientation {
    display: grid;
    justify-content: center;
    padding: 2rem;
    font-family: 'Roboto', sans-serif;

    .header {
        display: flex;
        align-items: flex-start;
        background-color: #f7f7f7;
        padding: 1rem;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        margin-bottom: 1.5rem;
        width: 700px;

        .icon-container {
            background-color: #ff9830;
            border-radius: 8px;
            padding: 0.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 1rem;

            i {
                color: #fff;
                font-size: 2rem;
            }
        }

        .text-container {
            flex: 1;

            .title {
                font-weight: bold;
                font-size: 1.5rem;
                color: #002855;
                margin-bottom: 0.5rem;
            }

            .description {
                font-size: 1rem;
                color: #666;
            }
        }
    }

    .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        width: 100%;
        max-width: 700px;
        padding: 1rem;

        .left {
            display: flex;
            align-items: center;

            i {
                font-size: 1.5rem;
                margin-right: 0.5rem;
                color: #666;
            }

            span {
                font-size: 1rem;
                color: #333;
            }
        }

        .right {
            .switch {
                position: relative;
                display: inline-block;
                width: 34px;
                height: 20px;

                input {
                    opacity: 0;
                    width: 0;
                    height: 0;
                }

                .slider {
                    position: absolute;
                    cursor: pointer;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: #ccc;
                    transition: .4s;
                    border-radius: 34px;

                    &.round {
                        border-radius: 34px;
                    }

                    &:before {
                        position: absolute;
                        content: "";
                        height: 14px;
                        width: 14px;
                        left: 3px;
                        bottom: 3px;
                        background-color: white;
                        transition: .4s;
                        border-radius: 50%;
                    }
                }

                input:checked + .slider {
                    background-color: #ff9830;
                }

                input:checked + .slider:before {
                    transform: translateX(14px);
                }
            }
        }
    }
}
</style>
